module.exports = globalThis["\"DELETED_WORKERNODE\""];